import { type License, SpecialQualifications } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { LicenseStatuses } from "@src/appV2/Licenses/api/types";
import { addDays, isBefore, parseISO } from "date-fns";

/**
 * As part of https://linear.app/clipboardhealth/issue/ACT-3135/add-renew-license-button-to-the-license-card-in-the-manage-roles-and
 *
 * We want to show renew license button that will show instructions to renew the license to user.
 * This option is not available for all licenses. It's only available under certain conditions.
 */
export function shouldShowRenewLicenseInstructions(
  licenseAttributes: Pick<License["attributes"], "status" | "qualification" | "expiresAt">
): boolean {
  const { status, qualification, expiresAt } = licenseAttributes;

  if (qualification !== SpecialQualifications.CNA) {
    return false;
  }

  const isActiveWithCloseToExpirationDate =
    isDefined(expiresAt) &&
    status === LicenseStatuses.ACTIVE &&
    isBefore(parseISO(expiresAt), addDays(new Date(), 90));

  return (
    isActiveWithCloseToExpirationDate ||
    status === LicenseStatuses.EXPIRING ||
    status === LicenseStatuses.EXPIRED
  );
}
